export const MONTHS = [
  'ENERO',
  'FEBRERO',
  'MARZO',
  'ABRIL',
  'MAYO',
  'JUNIO',
  'JULIO',
  'AGOSTO',
  'SETIEMBRE',
  'OCTUBRE',
  'NOVIEMBRE',
  'DICIEMBRE'
];

export const ABREV_MONTHS = [
  'Ene',
  'Feb',
  'Mar',
  'Abr',
  'May',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Oct',
  'Nov',
  'Dic'
]

export const WEEKDAYS = [
  'Lun',
  'Mar',
  'Mie',
  'Jue',
  'Vie',
  'Sáb',
  'Dom'
];

export enum MONTH {
  FIRST = 0,
  LAST = 11
}

export enum WEEK_DAY_POSITION {
  LUNES = 0,
  MARTES = 1,
  MIERCOLES = 2,
  JUEVES = 3,
  VIERNES = 4,
  SABADO = 5,
  DOMINGO = 6
}
export const MAX_MONTHS: number = 3;

export enum STATE_MONTHS {
  PREV = 'prevMonth',
  NEXT = 'nextMonth',
  CURRENT = 'currentMonth'
}

export const getStateConfig = {
  1: 'dateSelectedComercioD',
  2: 'dateSelectedTalanD',
  3: 'dateSelectedComercioMS',
  4: 'dateSelectedTalanS',
  5: 'dateSelectedTalanLV',
  6: 'dateSelectedDeporSD',
  7: 'dateSelectedDeporLV'
}
